jQuery(function($) {

  if ( $('.wp-block-home-stage').length > 0 ) {
    // Initialize Swiper
    const swiper = new Swiper('.swiper', {
      // Optional parameters
      loop: true,
    
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });
  }

});